import React, { Component } from 'react';
import Modal from '../../../components/Modal';
import notifyLafit from '../../../utils/notifyLafit';

class Lafit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      obsLafit: '',
    };
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value })

  notify = () => {
    const { fdvID } = this.props;
    const { obsLafit } = this.state;
    this.props.closeModal();
    notifyLafit(fdvID, obsLafit).then(({ data }) => this.props.openAlert(data));
  }

  render() {
    const { obsLafit } = this.state;

    return (
      <Modal title='Notificar LAFIT' idModal='fdv-lafit' isOpen closeModal={this.props.closeModal} modalSize='modal-sm little-modal modal-margin-top'>
        <p className='mt-2 mb-2'>Al enviar esta notificacion se activara una alerta de riesgo por lavado de activos. Una persona encargada dará seguimiento al caso</p>
        <div className='form-group'>
          <div className='form-group'>
            <label className='labelInfo' htmlFor='obsLafit'>Observaciones</label>
            <textarea className='form-control' placeholder='Ingresa tus observaciones aquí' name='obsLafit' id='obsLafit' value={obsLafit} onChange={this.onChangeValue} maxLength='300' />
          </div>
        </div>
        <div className='modal-actions'>
          <button className='btn btn-default' onClick={this.props.closeModal}>Cancelar</button>
          <button className='btn btn-primary pull-right' onClick={this.notify}>Aceptar</button>
        </div>
      </Modal>
    );
  }
}

export default Lafit;



// WEBPACK FOOTER //
// ./src/pages/modals/Lafit/index.js